import { createSlice } from "@reduxjs/toolkit";

export const generalSettingSlice = createSlice({
    name:"generalSetting",
    initialState: {
        roleList:[],
    },
    reducers:{
        setRoleList: (state, action) => {
            state.roleList = action.payload;
        },
        resetGeneralSetting: (state)=> {
            state.roleList = [];
        },
    }
});

export const { setRoleList, resetGeneralSetting } = generalSettingSlice.actions;

export default generalSettingSlice.reducer;